import { useState, useMemo, useCallback } from 'react'
import { PdfConfigTemplateSingleTy } from '../types'
import PdfA4Renderer from './PdfA4Renderer'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import TwinIcon from '../../../../../../../baseComponents/TwinIcon'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import usePdfRendererStyles from './usePdfRendererStyles'

interface ConfigPdfWhitePaperProps extends ConfigPdfWhitePaperLogicProps {
    config: PdfConfigTemplateSingleTy
}

const ConfigPdfWhitePaper: React.FC<ConfigPdfWhitePaperProps> = ({ type, config, ...logic }) => {
    const { setRef, pageNumber, handleNextPageNumber, handlePrevPageNumber, getParsedStyles} = useConfigPdfWhitePaperLogic({ type, ...logic })
    let renderThis : JSX.Element | null= null
    if (config.pages && config.pages.length !== 0) {
        renderThis = <PdfA4Renderer page={config.pages[pageNumber]} />
    }
    let imageProps: TwinDictionary = {}
    const myStyles = {
        ...config.document.cssConfig,
        ...(getParsedStyles(config.pages?.[pageNumber]?.cssConfig || {}, config.document.cssConfig?.backgroundImageParsed ? true : false )),
    }
    if (myStyles?.backgroundImageParsed) {
        delete myStyles.background
        imageProps = {
            backgroundImage: `url("${myStyles.backgroundImageParsed}")`,
            backgroundSize: "100%",
            backgroundRepeat: 'no-repeat',
        }
    }
    const orientation = config.document.cssConfig?.orientation || ''
    const isLastPage = pageNumber === (config.pages.length - 1) || config.pages.length === 0
    const isFirstPage = pageNumber === 0 || config.pages.length === 0
    const { renderStyles } = usePdfRendererStyles()
    let myStylesRenderer = renderStyles(config.document.cssConfig)
    if(myStyles.height){
        myStylesRenderer.height = myStyles.height + 'mm'
        myStylesRenderer.minHeight = myStyles.height + 'mm'
    }
    if(myStyles.width){
        myStylesRenderer.width = myStyles.width + 'mm'
        myStylesRenderer.minWidth = myStyles.width + 'mm'
    }
    return (
        <div className='flex-auto flex flex-col right-side overflow-x-auto' ref={setRef}>
            <div className='whitepaper_buttons grid grid-cols-3 mb-15 ml-auto h-24 items-center'>
                <div className='mr-auto' >{!isFirstPage ? <TwinIcon className='w-20 h-20' icon={faChevronLeft} onClick={handlePrevPageNumber} />: null}</div>
                <div className='text-center'><TwinTrans transKey='page'>Página</TwinTrans> {pageNumber + 1}</div>
                <div className='ml-auto' >{!isLastPage ? <TwinIcon className='w-20 h-20' icon={faChevronRight} onClick={handleNextPageNumber} />: null}</div>
            </div>
            <div className='whitepaper_container flex w-fit overflow-y-auto mx-auto' >
                <div className={'overflow-hidden whitepaper ' + type + ' ' + orientation} style={{ ...myStylesRenderer, ...imageProps/*scale: String(memorizedScale)*/ }}>
                    {renderThis}
                </div>
            </div>
        </div>
    )
}

export type WhitePaperTy = 'a4'

const typeNumbers: Record<WhitePaperTy, number> = {
    a4: 1122.52
}

interface ConfigPdfWhitePaperLogicProps {
    type: WhitePaperTy
}

const useConfigPdfWhitePaperLogic = ({ type }: ConfigPdfWhitePaperLogicProps) => {
    const [ref, setRef] = useState<any | null>(null);
    const height = ref?.offsetHeight
    const memorizedScale = useMemo(() => height / typeNumbers[type] - 0.08, [type, height])
    const [pageNumber, setPageNumber] = useState<number>(0)

    const handleNextPageNumber = useCallback(() => {
        setPageNumber((old) => old + 1)
    }, [setPageNumber])

    const handlePrevPageNumber = useCallback(() => {
        setPageNumber((old) => old - 1)
    }, [setPageNumber])

    const getParsedStyles = useCallback((styles: any, imageBackground: boolean) => {
        for (const key in styles) {
            if (imageBackground && key === 'background') {
                delete styles[key]
            }
            if (!styles[key]) {
                delete styles[key]
            }
        }
        return styles
    }, [])

    return { memorizedScale, setRef, pageNumber, handleNextPageNumber, handlePrevPageNumber, getParsedStyles }
}

export default ConfigPdfWhitePaper